import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiSave } from 'react-icons/fi';
import SaveForLater from '.';
import useMedia from 'use-media';
import {
  makeSelectIsSubmittingFurniture,
  makeSelectSaveModeFurniture,
} from '../UserActions/selectors';
import { createStructuredSelector } from 'reselect';
import { RootState } from '../App/types';
import { useSelector } from 'react-redux';
import { SaveMode } from '../UserActions/constants';

interface StateProps {
  saveMode?: SaveMode;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  saveMode: makeSelectSaveModeFurniture(),
});

function SaveForLaterLink() {
  const [showSaveModal, setShowSaveModal] = useState<boolean>(false);
  const { saveMode } = useSelector(stateSelector);

  const { t } = useTranslation();

  const isMobile = useMedia({ maxWidth: 1023 });

  return (
    <>
      {showSaveModal && <SaveForLater show={setShowSaveModal} />}
      <div
        className="flex items-center"
        style={{ visibility: saveMode !== undefined ? 'hidden' : 'visible' }}
      >
        <button
          className="kewconf-btn-save text-gray-800 px-2 py-1 my-1  text-lg flex items-center justify-center "
          onClick={() => {
            setShowSaveModal(true);
          }}
        >
          <FiSave className="h-6 w-6" />
          {!isMobile && <span className="ml-2">{t('Save')}</span>}
        </button>
      </div>
    </>
  );
}

export default SaveForLaterLink;
